import React from "react";

const YoutubeFrame = ({ src, className }) => (
    <iframe
        src={src}
        title="Sealskin Supreme Car Cover"
        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className={className}
    />
);

export default YoutubeFrame;
